import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import { first } from 'rxjs/operators';
import * as i6 from 'base-enter-entities-relationship-details-library';
import { BaseEnterEntitiesRelationshipDetailsLibraryService } from 'base-enter-entities-relationship-details-library';
import * as i1 from 'dirty-check-store';
import * as i2 from '@ngrx/store';
import * as i3 from 'reference-library';
import * as i4 from 'cache-country-list';
import * as i5 from 'ngx-toastr';
import * as i7 from 'step-status-update-payload-service';
import * as i8 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i9 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i10 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i11 from 'primeng/divider';
import * as i12 from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import * as i13 from '@angular/common';
import * as i14 from 'primeng/table';
import * as i15 from 'primeng/api';
import * as i16 from 'primeng/inputnumber';
import * as i17 from 'file-upload-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import * as i18 from 'custom-questionnaire';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import * as i19 from 'primeng/button';
import * as i20 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as i21 from '@progress/kendo-angular-toolbar';
import * as i22 from 'editor-library';
import { EditorLibraryModule } from 'editor-library';
import * as i23 from 'primeng/radiobutton';
import * as i24 from 'primeng/dropdown';
import * as i25 from 'primeng/inputtext';
import * as i26 from 'primeng/tooltip';
import * as i27 from '@angular/material/icon';
import { PrimengLibraryModule } from 'primeng-library';
import { USCompanyAdditionalDetailsLibraryModule } from 'us-company-additional-details-library';

class EnterEntitiesRelationshipDetailsLibraryService {
    constructor() { }
}
EnterEntitiesRelationshipDetailsLibraryService.ɵfac = function EnterEntitiesRelationshipDetailsLibraryService_Factory(t) { return new (t || EnterEntitiesRelationshipDetailsLibraryService)(); };
EnterEntitiesRelationshipDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: EnterEntitiesRelationshipDetailsLibraryService, factory: EnterEntitiesRelationshipDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnterEntitiesRelationshipDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["relationshipBetCompanyInfoupload"];
const _c1 = ["principalProductOrServiceInfoupload"];
const _c2 = ["relationshipBetCompanyInfokendoeditor"];
const _c3 = ["principalProductOrServiceInfokendoeditor"];
function EnterEntitiesRelationshipDetailsLibraryComponent_div_24_small_57_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_24_small_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_div_24_small_57_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r24.enterRelationshipDetailsForm.get("relationshipBetCompany.relationshipBetCompanyInfo").errors["required"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "kendo-editor", 66, 67);
    i0.ɵɵlistener("valueChange", function EnterEntitiesRelationshipDetailsLibraryComponent_div_24_Template_kendo_editor_valueChange_1_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.relationshipBetCompanyInfoText = $event; })("valueChange", function EnterEntitiesRelationshipDetailsLibraryComponent_div_24_Template_kendo_editor_valueChange_1_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.relationshipBetCompanyInfoTextValueChange($event); });
    i0.ɵɵelementStart(3, "kendo-toolbar");
    i0.ɵɵelementStart(4, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(5, "kendo-toolbar-button", 68);
    i0.ɵɵelement(6, "kendo-toolbar-button", 69);
    i0.ɵɵelement(7, "kendo-toolbar-button", 70);
    i0.ɵɵelement(8, "kendo-toolbar-button", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(10, "kendo-toolbar-button", 72);
    i0.ɵɵelement(11, "kendo-toolbar-button", 73);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(13, "kendo-toolbar-button", 74);
    i0.ɵɵelement(14, "kendo-toolbar-button", 75);
    i0.ɵɵelement(15, "kendo-toolbar-button", 76);
    i0.ɵɵelement(16, "kendo-toolbar-button", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "kendo-toolbar-dropdownlist", 78);
    i0.ɵɵelement(18, "kendo-toolbar-dropdownlist", 79);
    i0.ɵɵelement(19, "kendo-toolbar-dropdownlist", 80);
    i0.ɵɵelement(20, "kendo-toolbar-colorpicker", 81);
    i0.ɵɵelement(21, "kendo-toolbar-colorpicker", 82);
    i0.ɵɵelementStart(22, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(23, "kendo-toolbar-button", 83);
    i0.ɵɵelement(24, "kendo-toolbar-button", 84);
    i0.ɵɵelement(25, "kendo-toolbar-button", 85);
    i0.ɵɵelement(26, "kendo-toolbar-button", 86);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(27, "kendo-toolbar-button", 87);
    i0.ɵɵelement(28, "kendo-toolbar-button", 88);
    i0.ɵɵelementStart(29, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(30, "kendo-toolbar-button", 89);
    i0.ɵɵelement(31, "kendo-toolbar-button", 90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(33, "kendo-toolbar-button", 91);
    i0.ɵɵelement(34, "kendo-toolbar-button", 92);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(35, "kendo-toolbar-button", 93);
    i0.ɵɵelement(36, "kendo-toolbar-button", 94);
    i0.ɵɵelement(37, "kendo-toolbar-button", 95);
    i0.ɵɵelement(38, "kendo-editor-insert-table-button");
    i0.ɵɵelementStart(39, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(40, "kendo-toolbar-button", 96);
    i0.ɵɵelement(41, "kendo-toolbar-button", 97);
    i0.ɵɵelement(42, "kendo-toolbar-button", 98);
    i0.ɵɵelement(43, "kendo-toolbar-button", 99);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(45, "kendo-toolbar-button", 100);
    i0.ɵɵelement(46, "kendo-toolbar-button", 101);
    i0.ɵɵelement(47, "kendo-toolbar-button", 102);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(49, "kendo-toolbar-button", 103);
    i0.ɵɵelement(50, "kendo-toolbar-button", 104);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(51, "kendo-toolbar-button", 105);
    i0.ɵɵelementStart(52, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(53, "kendo-toolbar-button", 106);
    i0.ɵɵelementStart(54, "kendo-toolbar-button", 107);
    i0.ɵɵlistener("click", function EnterEntitiesRelationshipDetailsLibraryComponent_div_24_Template_kendo_toolbar_button_click_54_listener() { i0.ɵɵrestoreView(_r27); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.relationshipBetCompanyInfoimageuploaddialog(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(55, "app-upload-image-dialog", 108, 109);
    i0.ɵɵtemplate(57, EnterEntitiesRelationshipDetailsLibraryComponent_div_24_small_57_Template, 2, 1, "small", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r22 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r0.relationshipBetCompanyInfoText);
    i0.ɵɵadvance(54);
    i0.ɵɵproperty("editor", _r22);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.enterRelationshipDetailsForm.get("relationshipBetCompany.relationshipBetCompanyInfo").valid && ctx_r0.enterRelationshipDetailsForm.get("relationshipBetCompany.relationshipBetCompanyInfo").touched && ctx_r0.enterRelationshipDetailsForm.get("relationshipBetCompany.relationshipBetCompanyInfo").errors);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 111);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r1.enterRelationshipDetailsForm.get("relationshipBetCompany.relationshipBetCompanyInfo").value, i0.ɵɵsanitizeHtml);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_31_small_57_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_31_small_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_div_31_small_57_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r32.enterRelationshipDetailsForm.get("principalProductOrService.principalProductOrServiceInfo").errors["required"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "kendo-editor", 112, 113);
    i0.ɵɵlistener("valueChange", function EnterEntitiesRelationshipDetailsLibraryComponent_div_31_Template_kendo_editor_valueChange_1_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(); return ctx_r34.principalProductOrServiceInfoText = $event; })("valueChange", function EnterEntitiesRelationshipDetailsLibraryComponent_div_31_Template_kendo_editor_valueChange_1_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.principalProductOrServiceInfoValueChange($event); });
    i0.ɵɵelementStart(3, "kendo-toolbar");
    i0.ɵɵelementStart(4, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(5, "kendo-toolbar-button", 68);
    i0.ɵɵelement(6, "kendo-toolbar-button", 69);
    i0.ɵɵelement(7, "kendo-toolbar-button", 70);
    i0.ɵɵelement(8, "kendo-toolbar-button", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(10, "kendo-toolbar-button", 72);
    i0.ɵɵelement(11, "kendo-toolbar-button", 73);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(13, "kendo-toolbar-button", 74);
    i0.ɵɵelement(14, "kendo-toolbar-button", 75);
    i0.ɵɵelement(15, "kendo-toolbar-button", 76);
    i0.ɵɵelement(16, "kendo-toolbar-button", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "kendo-toolbar-dropdownlist", 78);
    i0.ɵɵelement(18, "kendo-toolbar-dropdownlist", 79);
    i0.ɵɵelement(19, "kendo-toolbar-dropdownlist", 80);
    i0.ɵɵelement(20, "kendo-toolbar-colorpicker", 81);
    i0.ɵɵelement(21, "kendo-toolbar-colorpicker", 82);
    i0.ɵɵelementStart(22, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(23, "kendo-toolbar-button", 83);
    i0.ɵɵelement(24, "kendo-toolbar-button", 84);
    i0.ɵɵelement(25, "kendo-toolbar-button", 85);
    i0.ɵɵelement(26, "kendo-toolbar-button", 86);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(27, "kendo-toolbar-button", 87);
    i0.ɵɵelement(28, "kendo-toolbar-button", 88);
    i0.ɵɵelementStart(29, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(30, "kendo-toolbar-button", 89);
    i0.ɵɵelement(31, "kendo-toolbar-button", 90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(33, "kendo-toolbar-button", 91);
    i0.ɵɵelement(34, "kendo-toolbar-button", 92);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(35, "kendo-toolbar-button", 93);
    i0.ɵɵelement(36, "kendo-toolbar-button", 94);
    i0.ɵɵelement(37, "kendo-toolbar-button", 95);
    i0.ɵɵelement(38, "kendo-editor-insert-table-button");
    i0.ɵɵelementStart(39, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(40, "kendo-toolbar-button", 96);
    i0.ɵɵelement(41, "kendo-toolbar-button", 97);
    i0.ɵɵelement(42, "kendo-toolbar-button", 98);
    i0.ɵɵelement(43, "kendo-toolbar-button", 99);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(45, "kendo-toolbar-button", 100);
    i0.ɵɵelement(46, "kendo-toolbar-button", 101);
    i0.ɵɵelement(47, "kendo-toolbar-button", 102);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(49, "kendo-toolbar-button", 103);
    i0.ɵɵelement(50, "kendo-toolbar-button", 104);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(51, "kendo-toolbar-button", 105);
    i0.ɵɵelementStart(52, "kendo-toolbar-buttongroup");
    i0.ɵɵelement(53, "kendo-toolbar-button", 106);
    i0.ɵɵelementStart(54, "kendo-toolbar-button", 107);
    i0.ɵɵlistener("click", function EnterEntitiesRelationshipDetailsLibraryComponent_div_31_Template_kendo_toolbar_button_click_54_listener() { i0.ɵɵrestoreView(_r35); const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.principalProductOrServiceInfoimageuploaddialog(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(55, "app-upload-image-dialog", 108, 114);
    i0.ɵɵtemplate(57, EnterEntitiesRelationshipDetailsLibraryComponent_div_31_small_57_Template, 2, 1, "small", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r30 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r2.principalProductOrServiceInfoText);
    i0.ɵɵadvance(54);
    i0.ɵɵproperty("editor", _r30);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.enterRelationshipDetailsForm.get("principalProductOrService.principalProductOrServiceInfo").valid && ctx_r2.enterRelationshipDetailsForm.get("principalProductOrService.principalProductOrServiceInfo").touched && ctx_r2.enterRelationshipDetailsForm.get("principalProductOrService.principalProductOrServiceInfo").errors);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 111);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r3.enterRelationshipDetailsForm.get("principalProductOrService.principalProductOrServiceInfo").value, i0.ɵɵsanitizeHtml);
} }
const _c4 = function (a0) { return { "mr-3": a0 }; };
function EnterEntitiesRelationshipDetailsLibraryComponent_p_radioButton_42_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-radioButton", 115);
    i0.ɵɵlistener("onClick", function EnterEntitiesRelationshipDetailsLibraryComponent_p_radioButton_42_Template_p_radioButton_onClick_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.onCompOwnTypeCode(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const compOwnType_r38 = ctx.$implicit;
    const i_r39 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c4, i_r39 < ctx_r4.companyTypList.length - 1))("value", compOwnType_r38.code)("label", compOwnType_r38.name);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 116);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Required");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_div_3_small_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Required");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 38);
    i0.ɵɵtext(2, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 122);
    i0.ɵɵtemplate(4, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_div_3_small_4_Template, 3, 0, "small", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (!ctx_r42.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.corporateName").value || ctx_r42.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.corporateName").value && ctx_r42.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.corporateName").value.trim() === "") && (ctx_r42.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.corporateName").touched || ctx_r42.USCompanyAdditionalDetailsSubmited) && ctx_r42.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors && ctx_r42.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors["USCompanyAdditionalDetailsIsRequired"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_ng_template_4_small_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Required");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_ng_template_4_small_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Required");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 38);
    i0.ɵɵtext(2, "First Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 123);
    i0.ɵɵtemplate(4, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_ng_template_4_small_4_Template, 3, 0, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 119);
    i0.ɵɵelementStart(6, "label", 38);
    i0.ɵɵtext(7, "Last Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 124);
    i0.ɵɵtemplate(9, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_ng_template_4_small_9_Template, 3, 0, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 119);
    i0.ɵɵelementStart(11, "label", 125);
    i0.ɵɵtext(12, "Middle Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "input", 126);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (!ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.firstName").value || ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.firstName").value && ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.firstName").value.trim() === "") && (ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.firstName").touched || ctx_r43.USCompanyAdditionalDetailsSubmited) && ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors && ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors["USCompanyAdditionalDetailsIsRequired"]);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", (!ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.lastName").value || ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.lastName").value && ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.lastName").value.trim() === "") && (ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.lastName").touched || ctx_r43.USCompanyAdditionalDetailsSubmited) && ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors && ctx_r43.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors["USCompanyAdditionalDetailsIsRequired"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_small_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Required");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_div_10_small_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Required");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "label", 38);
    i0.ɵɵtext(2, "Immigration Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 127);
    i0.ɵɵtemplate(4, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_div_10_small_4_Template, 3, 0, "small", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r45.immigrationStatusList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r45.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.immigrationStatusId").value && (ctx_r45.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.immigrationStatusId").touched || ctx_r45.USCompanyAdditionalDetailsSubmited) && ctx_r45.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors && ctx_r45.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors["USCompanyAdditionalDetailsIsRequired"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_small_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Required");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "div", 117);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵtemplate(3, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_div_3_Template, 5, 1, "div", 118);
    i0.ɵɵtemplate(4, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_ng_template_4_Template, 14, 2, "ng-template", 28);
    i0.ɵɵelementStart(5, "div", 119);
    i0.ɵɵelementStart(6, "label", 38);
    i0.ɵɵtext(7, "Nationality");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "p-dropdown", 120);
    i0.ɵɵtemplate(9, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_small_9_Template, 3, 0, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_div_10_Template, 5, 2, "div", 118);
    i0.ɵɵelementStart(11, "div", 119);
    i0.ɵɵelementStart(12, "label", 38);
    i0.ɵɵtext(13, "Percent of ownership");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "p-inputNumber", 121);
    i0.ɵɵtemplate(15, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_small_15_Template, 3, 0, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r6.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.compOwnTypeCode").value === "CORPORATE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.compOwnTypeCode").value === "INDIVIDUAL");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r6.nationalityList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.nationality").value && (ctx_r6.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.nationality").touched || ctx_r6.USCompanyAdditionalDetailsSubmited) && ctx_r6.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors && ctx_r6.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors["USCompanyAdditionalDetailsIsRequired"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.compOwnTypeCode").value === "INDIVIDUAL");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("min", 0)("max", 100);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.ownershipPercent").value === null && (ctx_r6.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.ownershipPercent").touched || ctx_r6.USCompanyAdditionalDetailsSubmited) && ctx_r6.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors && ctx_r6.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors["USCompanyAdditionalDetailsIsRequired"]);
} }
const _c5 = function (a0) { return { "disabled": a0 }; };
function EnterEntitiesRelationshipDetailsLibraryComponent_button_47_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 128);
    i0.ɵɵlistener("click", function EnterEntitiesRelationshipDetailsLibraryComponent_button_47_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r52); const ctx_r51 = i0.ɵɵnextContext(); return ctx_r51.addUSCompanyAdditionalDetails(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c5, !(ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.compOwnTypeCode").value && ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.nationality").value && (ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.compOwnTypeCode").value === "INDIVIDUAL" && (ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.firstName").value && ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.firstName").value.trim() !== "") && (ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.lastName").value && ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.lastName").value.trim() !== "") && ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.immigrationStatusId").value || ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.compOwnTypeCode").value === "CORPORATE" && (ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.corporateName").value && ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.corporateName").value.trim() !== "")) && ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.ownershipPercent").value !== null)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.id").value ? "SAVE" : "ADD");
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_button_48_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 129);
    i0.ɵɵlistener("click", function EnterEntitiesRelationshipDetailsLibraryComponent_button_48_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(); return ctx_r53.onResetUSCompanyAdditionalDetails(); });
    i0.ɵɵtext(1, "CANCEL");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_56_th_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 132);
    i0.ɵɵtext(1, "Action");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 130);
    i0.ɵɵtext(2, "Type of Investor");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 130);
    i0.ɵɵtext(4, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 130);
    i0.ɵɵtext(6, "Nationality");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 130);
    i0.ɵɵtext(8, "Immigration Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 130);
    i0.ɵɵtext(10, "Percent of Ownership");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_56_th_11_Template, 2, 0, "th", 131);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("ngIf", !ctx_r9.disabledControls);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_57_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const USCompanyAdditionalDetail_r56 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", USCompanyAdditionalDetail_r56.firstName + " " + (USCompanyAdditionalDetail_r56.middleName ? USCompanyAdditionalDetail_r56.middleName + " " : "") + USCompanyAdditionalDetail_r56.lastName, " ");
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_57_td_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const USCompanyAdditionalDetail_r56 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", USCompanyAdditionalDetail_r56.corporateName, " ");
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_57_td_11_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "div", 133);
    i0.ɵɵelementStart(2, "button", 134);
    i0.ɵɵlistener("click", function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_57_td_11_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r64); const USCompanyAdditionalDetail_r56 = i0.ɵɵnextContext().$implicit; const ctx_r62 = i0.ɵɵnextContext(); return ctx_r62.onEditUSCompanyAdditionalDetail(USCompanyAdditionalDetail_r56); });
    i0.ɵɵelementStart(3, "mat-icon", 135);
    i0.ɵɵtext(4, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 136);
    i0.ɵɵlistener("click", function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_57_td_11_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r64); const USCompanyAdditionalDetail_r56 = i0.ɵɵnextContext().$implicit; const ctx_r65 = i0.ɵɵnextContext(); return ctx_r65.onDeleteUSCompanyAdditionalDetail(USCompanyAdditionalDetail_r56); });
    i0.ɵɵelementStart(6, "mat-icon", 137);
    i0.ɵɵtext(7, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_57_td_3_Template, 2, 1, "td", 19);
    i0.ɵɵtemplate(4, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_57_td_4_Template, 2, 1, "td", 19);
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_57_td_11_Template, 8, 0, "td", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const USCompanyAdditionalDetail_r56 = ctx.$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(USCompanyAdditionalDetail_r56.compOwnTypeName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", USCompanyAdditionalDetail_r56.compOwnTypeCode === "INDIVIDUAL");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", USCompanyAdditionalDetail_r56.compOwnTypeCode === "CORPORATE");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(USCompanyAdditionalDetail_r56.nationalityName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(USCompanyAdditionalDetail_r56.immigrationStatusName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(USCompanyAdditionalDetail_r56.ownershipPercent + "%");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r10.disabledControls);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 138);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "No U.S company additional details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_70_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_70_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_small_70_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.assets").errors["required"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_75_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_75_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_small_75_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.netWorth").errors["required"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_80_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_80_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_small_80_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.netAnnualIncome").errors["required"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_97_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_97_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_small_97_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.enterRelationshipDetailsForm.get("otherRequiredDetails.numTotExecMngrEmp").errors["required"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_100_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_100_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_small_100_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.enterRelationshipDetailsForm.get("otherRequiredDetails.numExecMngrEmpEHLStat").errors["required"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_111_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_111_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_small_111_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.enterRelationshipDetailsForm.get("otherRequiredDetails.numTotPosSpecQual").errors["required"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_114_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_114_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_small_114_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.enterRelationshipDetailsForm.get("otherRequiredDetails.numPosSpecQualEHLStat").errors["required"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_124_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_small_124_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_small_124_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.enterRelationshipDetailsForm.get("otherRequiredDetails.numEmpBenSuprvs").errors["required"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_18_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_18_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r75.enterRelationshipDetailsForm.get("TradeDetailsE1").errors["TradeDetailsE1IsRequired"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_21_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_21_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r76.enterRelationshipDetailsForm.get("TradeDetailsE1").errors["TradeDetailsE1IsRequired"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_24_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_24_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r77.enterRelationshipDetailsForm.get("TradeDetailsE1").errors["TradeDetailsE1IsRequired"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_126_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 139);
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "div", 16);
    i0.ɵɵelementStart(3, "h6", 17);
    i0.ɵɵtext(4, "Trade Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵelementStart(6, "div", 140);
    i0.ɵɵelementStart(7, "label", 38);
    i0.ɵɵtext(8, "Total annual gross trade");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 140);
    i0.ɵɵelementStart(10, "label", 38);
    i0.ɵɵtext(11, "Year ending");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 140);
    i0.ɵɵelementStart(13, "label", 38);
    i0.ɵɵtext(14, "% of total gross trade between US and treaty trader country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 24);
    i0.ɵɵelementStart(16, "div", 37);
    i0.ɵɵelement(17, "p-inputNumber", 141);
    i0.ɵɵtemplate(18, EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_18_Template, 2, 1, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 37);
    i0.ɵɵelement(20, "p-dropdown", 142);
    i0.ɵɵtemplate(21, EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_21_Template, 2, 1, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 37);
    i0.ɵɵelement(23, "p-inputNumber", 143);
    i0.ɵɵtemplate(24, EnterEntitiesRelationshipDetailsLibraryComponent_div_126_small_24_Template, 2, 1, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵadvance(17);
    i0.ɵɵproperty("min", 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.enterRelationshipDetailsForm.get("TradeDetailsE1.totAnnualGrossTrade").value === null && ctx_r20.enterRelationshipDetailsForm.get("TradeDetailsE1.totAnnualGrossTrade").touched && ctx_r20.enterRelationshipDetailsForm.get("TradeDetailsE1").errors);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("options", ctx_r20.yearEndingList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r20.enterRelationshipDetailsForm.get("TradeDetailsE1.totAnnualGrossTradeYrEnd").value && ctx_r20.enterRelationshipDetailsForm.get("TradeDetailsE1.totAnnualGrossTradeYrEnd").touched && ctx_r20.enterRelationshipDetailsForm.get("TradeDetailsE1").errors);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("min", 0)("max", 100);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.enterRelationshipDetailsForm.get("TradeDetailsE1.totPercGrossTradeUSTrtyCntry").value === null && ctx_r20.enterRelationshipDetailsForm.get("TradeDetailsE1.totPercGrossTradeUSTrtyCntry").touched && ctx_r20.enterRelationshipDetailsForm.get("TradeDetailsE1").errors);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_10_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_10_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r81.enterRelationshipDetailsForm.get("investmentDetailsE2").errors["investmentDetailsE2IsRequired"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_15_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_15_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.enterRelationshipDetailsForm.get("investmentDetailsE2").errors["investmentDetailsE2IsRequired"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_20_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_20_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r83 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.enterRelationshipDetailsForm.get("investmentDetailsE2").errors["investmentDetailsE2IsRequired"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_26_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_26_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r84 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r84.enterRelationshipDetailsForm.get("investmentDetailsE2").errors["investmentDetailsE2IsRequired"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_31_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 110);
    i0.ɵɵtemplate(1, EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_31_span_1_Template, 2, 0, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r85 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r85.enterRelationshipDetailsForm.get("investmentDetailsE2").errors["investmentDetailsE2IsRequired"]);
} }
function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_Template(rf, ctx) { if (rf & 1) {
    const _r92 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 144);
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "div", 16);
    i0.ɵɵelementStart(3, "h6", 25);
    i0.ɵɵtext(4, "Investment Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 24);
    i0.ɵɵelementStart(6, "div", 37);
    i0.ɵɵelementStart(7, "label", 38);
    i0.ɵɵtext(8, "Cash");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p-inputNumber", 145);
    i0.ɵɵlistener("onInput", function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_Template_p_inputNumber_onInput_9_listener($event) { i0.ɵɵrestoreView(_r92); const ctx_r91 = i0.ɵɵnextContext(); return ctx_r91.onChangeInvestment($event.value, "invstmntCash"); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_10_Template, 2, 1, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 37);
    i0.ɵɵelementStart(12, "label", 38);
    i0.ɵɵtext(13, "Equipment");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "p-inputNumber", 146);
    i0.ɵɵlistener("onInput", function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_Template_p_inputNumber_onInput_14_listener($event) { i0.ɵɵrestoreView(_r92); const ctx_r93 = i0.ɵɵnextContext(); return ctx_r93.onChangeInvestment($event.value, "invstmntEquipment"); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_15_Template, 2, 1, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 37);
    i0.ɵɵelementStart(17, "label", 38);
    i0.ɵɵtext(18, "Other");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "p-inputNumber", 147);
    i0.ɵɵlistener("onInput", function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_Template_p_inputNumber_onInput_19_listener($event) { i0.ɵɵrestoreView(_r92); const ctx_r94 = i0.ɵɵnextContext(); return ctx_r94.onChangeInvestment($event.value, "invstmntOther"); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_20_Template, 2, 1, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 24);
    i0.ɵɵelementStart(22, "div", 37);
    i0.ɵɵelementStart(23, "label", 38);
    i0.ɵɵtext(24, "Inventory");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "p-inputNumber", 148);
    i0.ɵɵlistener("onInput", function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_Template_p_inputNumber_onInput_25_listener($event) { i0.ɵɵrestoreView(_r92); const ctx_r95 = i0.ɵɵnextContext(); return ctx_r95.onChangeInvestment($event.value, "invstmntInvntry"); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_26_Template, 2, 1, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 37);
    i0.ɵɵelementStart(28, "label", 38);
    i0.ɵɵtext(29, "Premises");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "p-inputNumber", 149);
    i0.ɵɵlistener("onInput", function EnterEntitiesRelationshipDetailsLibraryComponent_div_127_Template_p_inputNumber_onInput_30_listener($event) { i0.ɵɵrestoreView(_r92); const ctx_r96 = i0.ɵɵnextContext(); return ctx_r96.onChangeInvestment($event.value, "invstmntPremise"); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(31, EnterEntitiesRelationshipDetailsLibraryComponent_div_127_small_31_Template, 2, 1, "small", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "div", 37);
    i0.ɵɵelementStart(33, "label", 125);
    i0.ɵɵtext(34, "Total");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(35, "input", 150);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("maxlength", 15)("min", 0)("max", 999999999999999);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2.invstmntCash").value === null && ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2.invstmntCash").touched && ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2").errors);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("maxlength", 15)("min", 0)("max", 999999999999999);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2.invstmntEquipment").value === null && ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2.invstmntEquipment").touched && ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2").errors);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("maxlength", 15)("min", 0)("max", 999999999999999);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2.invstmntOther").value === null && ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2.invstmntOther").touched && ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2").errors);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("maxlength", 15)("min", 0)("max", 999999999999999);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2.invstmntInvntry").value === null && ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2.invstmntInvntry").touched && ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2").errors);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("maxlength", 15)("min", 0)("max", 999999999999999);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2.invstmntPremise").value === null && ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2.invstmntPremise").touched && ctx_r21.enterRelationshipDetailsForm.get("investmentDetailsE2").errors);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", true);
} }
const _c6 = function (a0) { return { "layoutCode": a0 }; };
class EnterEntitiesRelationshipDetailsLibraryComponent extends BaseEnterEntitiesRelationshipDetailsLibraryService {
    constructor(guard, store, referenceLibraryService, cacheCountyService, toastrService, apiEnterEntitiesRelationshipDetailsLibraryService, stepStatusUpdatePayloadService, stepStatusUpdateComponentLibraryService) {
        super(guard, store, referenceLibraryService, cacheCountyService, toastrService, apiEnterEntitiesRelationshipDetailsLibraryService, stepStatusUpdatePayloadService, stepStatusUpdateComponentLibraryService);
        this.guard = guard;
        this.store = store;
        this.referenceLibraryService = referenceLibraryService;
        this.cacheCountyService = cacheCountyService;
        this.toastrService = toastrService;
        this.apiEnterEntitiesRelationshipDetailsLibraryService = apiEnterEntitiesRelationshipDetailsLibraryService;
        this.stepStatusUpdatePayloadService = stepStatusUpdatePayloadService;
        this.stepStatusUpdateComponentLibraryService = stepStatusUpdateComponentLibraryService;
        this.dialogClose = new EventEmitter();
        this.showNext = false;
        this.showPrev = false;
    }
    ngOnInit() {
        var _a, _b;
        super.loadInit();
        this.showNext = (_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.showNext;
        this.showPrev = (_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.showPrev;
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.dialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    relationshipBetCompanyInfoimageuploaddialog() {
        this.relationshipBetCompanyInfoupload.open();
    }
    principalProductOrServiceInfoimageuploaddialog() {
        this.principalProductOrServiceInfoupload.open();
    }
    relationshipBetCompanyInfoTextValueChange(value) {
        this.relationshipBetCompanyInfoText = value;
    }
    principalProductOrServiceInfoValueChange(value) {
        this.principalProductOrServiceInfoText = value;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
EnterEntitiesRelationshipDetailsLibraryComponent.ɵfac = function EnterEntitiesRelationshipDetailsLibraryComponent_Factory(t) { return new (t || EnterEntitiesRelationshipDetailsLibraryComponent)(i0.ɵɵdirectiveInject(i1.DirtyFormGuard), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.ReferenceLibraryService), i0.ɵɵdirectiveInject(i4.CacheCountryListService), i0.ɵɵdirectiveInject(i5.ToastrService), i0.ɵɵdirectiveInject(i6.ApiEnterEntitiesRelationshipDetailsLibraryService), i0.ɵɵdirectiveInject(i7.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i8.StepStatusUpdateComponentLibraryService)); };
EnterEntitiesRelationshipDetailsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EnterEntitiesRelationshipDetailsLibraryComponent, selectors: [["lib-enter-entities-relationship-details-library"]], viewQuery: function EnterEntitiesRelationshipDetailsLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
        i0.ɵɵviewQuery(_c1, 1);
        i0.ɵɵviewQuery(_c2, 1);
        i0.ɵɵviewQuery(_c3, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.relationshipBetCompanyInfoupload = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.principalProductOrServiceInfoupload = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.relationshipBetCompanyInfokendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.principalProductOrServiceInfokendoeditor = _t.first);
    } }, inputs: { primaryData: "primaryData" }, outputs: { dialogClose: "dialogClose", relationshipBetCompanyInfokendoeditor: "relationshipBetCompanyInfokendoeditor", principalProductOrServiceInfokendoeditor: "principalProductOrServiceInfokendoeditor" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 146, vars: 77, consts: [[1, "container-fuild"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-8", "step-title", "p-0"], [1, "page-header"], [1, "col-md-4", "editBtn", "headerSubPortion", "px-0"], [1, "col-auto", "px-0", "firstPortion"], ["type", "EDIT", 1, "float-right", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "col-auto", "pr-0", "pl-2", "secondPortion"], [3, "configData"], [1, "close-icon", "pi", "pi-times", "pull-right", 3, "click"], [1, "row"], [1, "col-md-12", "p-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], [1, "p-form", 3, "formGroup", "ngSubmit"], [1, "main-body", "footer-adjust"], ["formGroupName", "relationshipBetCompany", 1, "mt-2", "mb-4"], [1, "col-12"], [1, "greencard-pwd-sub-header"], ["class", "beneficiary-experience-froala-editor", 4, "ngIf"], [4, "ngIf"], ["formGroupName", "principalProductOrService", 1, "mb-4"], ["type", "dashed", 1, "d-block", "mb-4"], ["formGroupName", "USCompanyAdditionalDetails", 1, "mt-2", "mb-4"], ["formGroupName", "detailsForm"], [1, "row", "mb-3"], [1, "heading", "p-text-bold"], ["formControlName", "compOwnTypeCode", "name", "compOwnTypeCode", 3, "ngClass", "value", "label", "onClick", 4, "ngFor", "ngForOf"], ["class", "p-error d-block", 4, "ngIf"], [3, "ngIf"], [1, "row", "mb-4"], ["type", "button", "class", "p-btn btn btn-primary mr-3", 3, "ngClass", "click", 4, "ngIf"], ["type", "button", "class", "btn btn-primary", 3, "click", 4, "ngIf"], [1, "p-label", "p-label-blue", "p-label-bold"], ["tableStyleClass", "visa-table", 1, "table-striped-simple", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["formGroupName", "assetsNetWorthNetAnnualIncomeDetails", 1, "mt-2", "mb-4"], [1, "form-group", "col-3"], [1, "p-label", "required"], ["formControlName", "assets", "placeholder", "Enter", "mode", "currency", "currency", "USD", "locale", "en-US", 1, "p-form-control", 3, "maxlength", "min", "max"], ["class", "p-error", 4, "ngIf"], ["formControlName", "netWorth", "placeholder", "Enter", "mode", "currency", "currency", "USD", "locale", "en-US", 1, "p-form-control", 3, "maxlength", "min", "max"], ["formControlName", "netAnnualIncome", "placeholder", "Enter", "mode", "currency", "currency", "USD", "locale", "en-US", 1, "p-form-control", 3, "maxlength", "min", "max"], ["formGroupName", "otherRequiredDetails", 1, "mt-2", "mb-4"], [1, "col-6"], [1, "form-group", "col-6"], ["formControlName", "numTotExecMngrEmp", "placeholder", "Enter", 1, "p-form-control", 3, "useGrouping", "maxlength", "min", "max"], ["formControlName", "numExecMngrEmpEHLStat", "placeholder", "Enter", 1, "p-form-control", 3, "useGrouping", "maxlength", "min", "max"], ["formControlName", "numTotPosSpecQual", "placeholder", "Enter", 1, "p-form-control", 3, "useGrouping", "maxlength", "min", "max"], ["formControlName", "numPosSpecQualEHLStat", "placeholder", "Enter", 1, "p-form-control", 3, "useGrouping", "maxlength", "min", "max"], [1, "p-label", "required", "d-block", "mb-n2"], [1, "p-label", "p-label-small"], ["formControlName", "numEmpBenSuprvs", "placeholder", "Enter", 1, "p-form-control", 3, "useGrouping", "maxlength", "min", "max"], ["formGroupName", "TradeDetailsE1", "class", "mt-2 mb-4", 4, "ngIf"], ["formGroupName", "investmentDetailsE2", "class", "mt-2 mb-4", 4, "ngIf"], [1, "row", "mt-2", "mb-3"], [2, "width", "100%", 3, "fileUploadConfigurations"], [1, "row", "pt-3", "mt-n3"], [3, "stepId", "taskId", "viewQuestions", "showSaveBtn", "loadedIn", "isSection"], [1, "row", "pt-3"], [1, "col-md-6", "d-flex", "justify-content-start"], ["pButton", "", "type", "submit", "label", "Save", 1, "btn", "btn-primary", 3, "ngClass", "disabled"], ["pButton", "", "type", "button", "label", "Cancel", 1, "d-flex", "alogn-items-center", "btn", "btn-primary", "ml-3", 3, "disabled", "click"], [1, "col-md-6", "completeStep"], [1, "d-flex", "col-12", "justify-content-end", 3, "visaType", "stepDetails", "type", "showPreviousStepBtn", "showNextStepBtn"], [1, "beneficiary-experience-froala-editor"], ["formControlName", "relationshipBetCompanyInfo", "name", "relationshipBetCompanyInfo", 2, "height", "400px", 3, "value", "valueChange"], ["relationshipBetCompanyInfokendoeditor", ""], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorStrikethroughButton", ""], ["kendoEditorSubscriptButton", ""], ["kendoEditorSuperscriptButton", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorFormat", ""], ["kendoEditorFontSize", ""], ["kendoEditorFontFamily", ""], ["kendoEditorForeColor", ""], ["kendoEditorBackColor", "", "view", "gradient"], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorBlockquoteButton", ""], ["kendoEditorSelectAllButton", ""], ["kendoEditorUndoButton", ""], ["kendoEditorRedoButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertFileButton", ""], ["kendoEditorViewSourceButton", ""], ["kendoEditorCleanFormattingButton", ""], ["kendoEditorAddColumnBeforeButton", ""], ["kendoEditorAddColumnAfterButton", ""], ["kendoEditorAddRowBeforeButton", ""], ["kendoEditorAddRowAfterButton", ""], ["kendoEditorDeleteColumnButton", ""], ["kendoEditorDeleteRowButton", ""], ["kendoEditorDeleteTableButton", ""], ["kendoEditorMergeCellsButton", ""], ["kendoEditorSplitCellButton", ""], ["kendoEditorPrintButton", ""], ["kendoEditorInsertImageButton", ""], ["title", "Upload\u2019s Image at cursor point", "text", "Upload Image", 3, "click"], [3, "editor"], ["relationshipBetCompanyInfoupload", ""], [1, "p-error"], [3, "innerHTML"], ["formControlName", "principalProductOrServiceInfo", "name", "principalProductOrServiceInfo", 2, "height", "400px", 3, "value", "valueChange"], ["principalProductOrServiceInfokendoeditor", ""], ["principalProductOrServiceInfoupload", ""], ["formControlName", "compOwnTypeCode", "name", "compOwnTypeCode", 3, "ngClass", "value", "label", "onClick"], [1, "p-error", "d-block"], [1, "col-9"], ["class", "form-group col-4", 4, "ngIf"], [1, "form-group", "col-4"], ["appendTo", "body", "placeholder", "Select", "optionValue", "code", "optionLabel", "name", "formControlName", "nationality", 1, "p-form-control", 3, "options"], ["formControlName", "ownershipPercent", "placeholder", "Enter", "suffix", "%", 1, "p-form-control", 3, "min", "max"], ["type", "text", "pInputText", "", "placeholder", "Enter", "formControlName", "corporateName", 1, "p-form-control"], ["type", "text", "pInputText", "", "placeholder", "Enter", "formControlName", "firstName", 1, "p-form-control"], ["type", "text", "pInputText", "", "placeholder", "Enter", "formControlName", "lastName", 1, "p-form-control"], [1, "p-label"], ["type", "text", "pInputText", "", "placeholder", "Enter", "formControlName", "middleName", 1, "p-form-control"], ["appendTo", "body", "placeholder", "Select", "optionValue", "id", "optionLabel", "name", "formControlName", "immigrationStatusId", 1, "p-form-control", 3, "options"], ["type", "button", 1, "p-btn", "btn", "btn-primary", "mr-3", 3, "ngClass", "click"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], ["scope", "col"], ["scope", "col", "class", "text-center", 4, "ngIf"], ["scope", "col", 1, "text-center"], [1, "subtask-form-header-buttons-holder", "float-right", "mr-3"], ["type", "button", "pTooltip", "Edit", "pButton", "", 1, "p-button-text", "p-button-rounded", 3, "click"], ["matTooltip", "Edit", 1, "mr-1", "icn"], ["type", "button", "pTooltip", "Delete", "pButton", "", 1, "p-button-text", "p-button-rounded", 3, "click"], ["matTooltip", "Delete", 1, "mr-1", "icn"], [1, "visa-row-nodata"], ["formGroupName", "TradeDetailsE1", 1, "mt-2", "mb-4"], [1, "col-3"], ["formControlName", "totAnnualGrossTrade", "placeholder", "Enter", "mode", "currency", "currency", "USD", "locale", "en-US", 1, "p-form-control", 3, "min"], ["appendTo", "body", "placeholder", "Select", "optionValue", "value", "optionLabel", "label", "formControlName", "totAnnualGrossTradeYrEnd", 1, "p-form-control", 3, "options"], ["formControlName", "totPercGrossTradeUSTrtyCntry", "placeholder", "Enter", "suffix", "%", 1, "p-form-control", 3, "min", "max"], ["formGroupName", "investmentDetailsE2", 1, "mt-2", "mb-4"], ["formControlName", "invstmntCash", "placeholder", "Enter", "mode", "currency", "currency", "USD", "locale", "en-US", 1, "p-form-control", 3, "maxlength", "min", "max", "onInput"], ["formControlName", "invstmntEquipment", "placeholder", "Enter", "mode", "currency", "currency", "USD", "locale", "en-US", 1, "p-form-control", 3, "maxlength", "min", "max", "onInput"], ["formControlName", "invstmntOther", "placeholder", "Enter", "mode", "currency", "currency", "USD", "locale", "en-US", 1, "p-form-control", 3, "maxlength", "min", "max", "onInput"], ["formControlName", "invstmntInvntry", "placeholder", "Enter", "mode", "currency", "currency", "USD", "locale", "en-US", 1, "p-form-control", 3, "maxlength", "min", "max", "onInput"], ["formControlName", "invstmntPremise", "placeholder", "Enter", "mode", "currency", "currency", "USD", "locale", "en-US", 1, "p-form-control", 3, "maxlength", "min", "max", "onInput"], ["type", "text", "pInputText", "", "formControlName", "invstmntTotal", "placeholder", "Enter", 1, "p-form-control", 3, "readonly"]], template: function EnterEntitiesRelationshipDetailsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "h2");
        i0.ɵɵtext(5, "Enter Entities Relationship Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "ul");
        i0.ɵɵelementStart(8, "li", 5);
        i0.ɵɵelement(9, "lib-step-status-update-component-library", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "li", 7);
        i0.ɵɵelement(11, "lib-maximize-dialog-library", 8);
        i0.ɵɵelementStart(12, "i", 9);
        i0.ɵɵlistener("click", function EnterEntitiesRelationshipDetailsLibraryComponent_Template_i_click_12_listener() { return ctx.handleClose(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 10);
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵelementStart(15, "lib-assigning-task-library", 12);
        i0.ɵɵlistener("updateStatus", function EnterEntitiesRelationshipDetailsLibraryComponent_Template_lib_assigning_task_library_updateStatus_15_listener($event) { return ctx.updateStepStatus($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(16, "p-divider");
        i0.ɵɵelementStart(17, "form", 13);
        i0.ɵɵlistener("ngSubmit", function EnterEntitiesRelationshipDetailsLibraryComponent_Template_form_ngSubmit_17_listener() { return ctx.onSubmit(); });
        i0.ɵɵelementStart(18, "div", 14);
        i0.ɵɵelementStart(19, "div", 15);
        i0.ɵɵelementStart(20, "div", 10);
        i0.ɵɵelementStart(21, "div", 16);
        i0.ɵɵelementStart(22, "h6", 17);
        i0.ɵɵtext(23, "Explain relationship between companies");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(24, EnterEntitiesRelationshipDetailsLibraryComponent_div_24_Template, 58, 3, "div", 18);
        i0.ɵɵtemplate(25, EnterEntitiesRelationshipDetailsLibraryComponent_div_25_Template, 2, 1, "div", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 20);
        i0.ɵɵelementStart(27, "div", 10);
        i0.ɵɵelementStart(28, "div", 16);
        i0.ɵɵelementStart(29, "h6", 17);
        i0.ɵɵtext(30, "Explain the details of Principal Product, Merchandise or Service");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(31, EnterEntitiesRelationshipDetailsLibraryComponent_div_31_Template, 58, 3, "div", 18);
        i0.ɵɵtemplate(32, EnterEntitiesRelationshipDetailsLibraryComponent_div_32_Template, 2, 1, "div", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(33, "p-divider", 21);
        i0.ɵɵelementStart(34, "div", 22);
        i0.ɵɵelementStart(35, "div", 23);
        i0.ɵɵelementStart(36, "div", 24);
        i0.ɵɵelementStart(37, "div", 16);
        i0.ɵɵelementStart(38, "h6", 25);
        i0.ɵɵtext(39, "U.S company additional details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(40, "div", 24);
        i0.ɵɵelementStart(41, "div", 16);
        i0.ɵɵtemplate(42, EnterEntitiesRelationshipDetailsLibraryComponent_p_radioButton_42_Template, 1, 5, "p-radioButton", 26);
        i0.ɵɵtemplate(43, EnterEntitiesRelationshipDetailsLibraryComponent_small_43_Template, 3, 0, "small", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(44, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_44_Template, 16, 8, "ng-template", 28);
        i0.ɵɵelementStart(45, "div", 29);
        i0.ɵɵelementStart(46, "div", 16);
        i0.ɵɵtemplate(47, EnterEntitiesRelationshipDetailsLibraryComponent_button_47_Template, 2, 4, "button", 30);
        i0.ɵɵtemplate(48, EnterEntitiesRelationshipDetailsLibraryComponent_button_48_Template, 2, 0, "button", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(49, "div", 24);
        i0.ɵɵelementStart(50, "div", 16);
        i0.ɵɵelementStart(51, "label", 32);
        i0.ɵɵtext(52, "Added U.S company additional details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(53, "div", 24);
        i0.ɵɵelementStart(54, "div", 16);
        i0.ɵɵelementStart(55, "p-table", 33);
        i0.ɵɵtemplate(56, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_56_Template, 12, 1, "ng-template", 34);
        i0.ɵɵtemplate(57, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_57_Template, 12, 7, "ng-template", 35);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(58, EnterEntitiesRelationshipDetailsLibraryComponent_ng_template_58_Template, 3, 0, "ng-template", 28);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(59, "p-divider", 21);
        i0.ɵɵelementStart(60, "div", 36);
        i0.ɵɵelementStart(61, "div", 24);
        i0.ɵɵelementStart(62, "div", 16);
        i0.ɵɵelementStart(63, "h6", 25);
        i0.ɵɵtext(64, "Assets, Net Worth, Net Annual Income Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(65, "div", 24);
        i0.ɵɵelementStart(66, "div", 37);
        i0.ɵɵelementStart(67, "label", 38);
        i0.ɵɵtext(68, "Assets");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(69, "p-inputNumber", 39);
        i0.ɵɵtemplate(70, EnterEntitiesRelationshipDetailsLibraryComponent_small_70_Template, 2, 1, "small", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(71, "div", 37);
        i0.ɵɵelementStart(72, "label", 38);
        i0.ɵɵtext(73, "Net Worth");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(74, "p-inputNumber", 41);
        i0.ɵɵtemplate(75, EnterEntitiesRelationshipDetailsLibraryComponent_small_75_Template, 2, 1, "small", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(76, "div", 37);
        i0.ɵɵelementStart(77, "label", 38);
        i0.ɵɵtext(78, "Net Annual Income");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(79, "p-inputNumber", 42);
        i0.ɵɵtemplate(80, EnterEntitiesRelationshipDetailsLibraryComponent_small_80_Template, 2, 1, "small", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(81, "p-divider", 21);
        i0.ɵɵelementStart(82, "div", 43);
        i0.ɵɵelementStart(83, "div", 24);
        i0.ɵɵelementStart(84, "div", 16);
        i0.ɵɵelementStart(85, "h6", 25);
        i0.ɵɵtext(86, "Other Required details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(87, "div", 10);
        i0.ɵɵelementStart(88, "div", 44);
        i0.ɵɵelementStart(89, "label", 38);
        i0.ɵɵtext(90, "Total no. of executives or managerial employees");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(91, "div", 44);
        i0.ɵɵelementStart(92, "label", 38);
        i0.ɵɵtext(93, "No. of executives or managerial employees on E, H & L non-immigrant status");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(94, "div", 24);
        i0.ɵɵelementStart(95, "div", 45);
        i0.ɵɵelement(96, "p-inputNumber", 46);
        i0.ɵɵtemplate(97, EnterEntitiesRelationshipDetailsLibraryComponent_small_97_Template, 2, 1, "small", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(98, "div", 45);
        i0.ɵɵelement(99, "p-inputNumber", 47);
        i0.ɵɵtemplate(100, EnterEntitiesRelationshipDetailsLibraryComponent_small_100_Template, 2, 1, "small", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(101, "div", 10);
        i0.ɵɵelementStart(102, "div", 44);
        i0.ɵɵelementStart(103, "label", 38);
        i0.ɵɵtext(104, "Total no. of position that require persons with specialty qualifications");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(105, "div", 44);
        i0.ɵɵelementStart(106, "label", 38);
        i0.ɵɵtext(107, "No. of persons with special qualifications on E, H & L non-immigrant status");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(108, "div", 24);
        i0.ɵɵelementStart(109, "div", 45);
        i0.ɵɵelement(110, "p-inputNumber", 48);
        i0.ɵɵtemplate(111, EnterEntitiesRelationshipDetailsLibraryComponent_small_111_Template, 2, 1, "small", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(112, "div", 45);
        i0.ɵɵelement(113, "p-inputNumber", 49);
        i0.ɵɵtemplate(114, EnterEntitiesRelationshipDetailsLibraryComponent_small_114_Template, 2, 1, "small", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(115, "div", 10);
        i0.ɵɵelementStart(116, "div", 44);
        i0.ɵɵelementStart(117, "label", 50);
        i0.ɵɵtext(118, "Total no. of employees the beneficiary will supervise");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(119, "label", 51);
        i0.ɵɵtext(120, "[for positions like executives or manager]");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(121, "div", 24);
        i0.ɵɵelementStart(122, "div", 45);
        i0.ɵɵelement(123, "p-inputNumber", 52);
        i0.ɵɵtemplate(124, EnterEntitiesRelationshipDetailsLibraryComponent_small_124_Template, 2, 1, "small", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(125, "p-divider", 21);
        i0.ɵɵtemplate(126, EnterEntitiesRelationshipDetailsLibraryComponent_div_126_Template, 25, 7, "div", 53);
        i0.ɵɵtemplate(127, EnterEntitiesRelationshipDetailsLibraryComponent_div_127_Template, 36, 21, "div", 54);
        i0.ɵɵelement(128, "p-divider", 21);
        i0.ɵɵelementStart(129, "div", 55);
        i0.ɵɵelementStart(130, "div", 16);
        i0.ɵɵelementStart(131, "h6", 25);
        i0.ɵɵtext(132, "Upload Documents");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(133, "div", 29);
        i0.ɵɵelementStart(134, "div", 11);
        i0.ɵɵelement(135, "file-upload-library", 56);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(136, "p-divider", 21);
        i0.ɵɵelementStart(137, "div", 57);
        i0.ɵɵelement(138, "lib-custom-questionnaire", 58);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(139, "p-divider", 21);
        i0.ɵɵelementStart(140, "div", 59);
        i0.ɵɵelementStart(141, "div", 60);
        i0.ɵɵelement(142, "button", 61);
        i0.ɵɵelementStart(143, "button", 62);
        i0.ɵɵlistener("click", function EnterEntitiesRelationshipDetailsLibraryComponent_Template_button_click_143_listener() { return ctx.handleCancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(144, "div", 63);
        i0.ɵɵelement(145, "lib-step-status-update-component-library", 64);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("visaType", ctx.primaryData.caseType != "I130" ? ctx.primaryData.visatype : ctx.primaryData.caseType)("stepDetails", ctx.stepDetails)("isViewMode", ctx.primaryData["isViewMode"])("isCaseRequest", ctx.primaryData["isCaseRequest"]);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(75, _c6, ctx.primaryData == null ? null : ctx.primaryData.layoutCode));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("visaType", ctx.primaryData.visatype)("stepDetails", ctx.stepDetails)("isViewMode", ctx.primaryData["isViewMode"])("isCaseRequest", ctx.primaryData["isCaseRequest"]);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.enterRelationshipDetailsForm);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", !ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.disabledControls);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", !ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.disabledControls);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngForOf", ctx.companyTypList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.compOwnTypeCode").value && (ctx.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.compOwnTypeCode").touched || ctx.USCompanyAdditionalDetailsSubmited) && ctx.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors && ctx.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm").errors["USCompanyAdditionalDetailsIsRequired"]);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.enterRelationshipDetailsForm.get("USCompanyAdditionalDetails.detailsForm.compOwnTypeCode").value);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.disabledControls);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("value", ctx.USCompanyAdditionalDetailsArray);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.USCompanyAdditionalDetailsArray.length === 0);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("maxlength", 15)("min", 0)("max", 999999999999999);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.assets").valid && ctx.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.assets").touched && ctx.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.assets").errors);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("maxlength", 15)("min", 0)("max", 999999999999999);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.netWorth").valid && ctx.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.netWorth").touched && ctx.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.netWorth").errors);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("maxlength", 15)("min", 0)("max", 999999999999999);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.netAnnualIncome").valid && ctx.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.netAnnualIncome").touched && ctx.enterRelationshipDetailsForm.get("assetsNetWorthNetAnnualIncomeDetails.netAnnualIncome").errors);
        i0.ɵɵadvance(16);
        i0.ɵɵproperty("useGrouping", false)("maxlength", 8)("min", 0)("max", 99999999);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numTotExecMngrEmp").valid && ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numTotExecMngrEmp").touched && ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numTotExecMngrEmp").errors);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("useGrouping", false)("maxlength", 8)("min", 0)("max", 99999999);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numExecMngrEmpEHLStat").valid && ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numExecMngrEmpEHLStat").touched && ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numExecMngrEmpEHLStat").errors);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("useGrouping", false)("maxlength", 8)("min", 0)("max", 99999999);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numTotPosSpecQual").valid && ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numTotPosSpecQual").touched && ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numTotPosSpecQual").errors);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("useGrouping", false)("maxlength", 8)("min", 0)("max", 99999999);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numPosSpecQualEHLStat").valid && ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numPosSpecQualEHLStat").touched && ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numPosSpecQualEHLStat").errors);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("useGrouping", false)("maxlength", 8)("min", 0)("max", 99999999);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numEmpBenSuprvs").valid && ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numEmpBenSuprvs").touched && ctx.enterRelationshipDetailsForm.get("otherRequiredDetails.numEmpBenSuprvs").errors);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.fields.showTradeDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fields.showInvestmentDetails);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("fileUploadConfigurations", ctx.fileUploadConfigurations);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("stepId", ctx.primaryData.stepId)("taskId", ctx.primaryData.taskId)("viewQuestions", false)("showSaveBtn", false)("loadedIn", "Enter Entities Relationship details")("isSection", false);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", ctx.enterRelationshipDetailsForm.invalid || ctx.disabledControls || (!ctx.USCompanyAdditionalDetailsArray || ctx.USCompanyAdditionalDetailsArray && ctx.USCompanyAdditionalDetailsArray.length === 0) ? "mr-3 btn-success_disabled btn btn-primary" : "mr-3 btn btn-primary")("disabled", ctx.enterRelationshipDetailsForm.invalid || ctx.disabledControls || (!ctx.USCompanyAdditionalDetailsArray || ctx.USCompanyAdditionalDetailsArray && ctx.USCompanyAdditionalDetailsArray.length === 0));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("visaType", ctx.primaryData.caseType != "I130" ? ctx.primaryData.visatype : ctx.primaryData.caseType)("stepDetails", ctx.stepDetails)("type", ctx.typeOfButton)("showPreviousStepBtn", ctx.showPrev)("showNextStepBtn", ctx.showNext);
    } }, directives: [i8.StepStatusUpdateComponentLibraryComponent, i9.MaximizeDialogLibraryComponent, i10.AssigningTaskLibraryComponent, i11.Divider, i12.ɵangular_packages_forms_forms_ba, i12.NgControlStatusGroup, i12.FormGroupDirective, i12.FormGroupName, i13.NgIf, i13.NgForOf, i14.Table, i15.PrimeTemplate, i16.InputNumber, i12.NgControlStatus, i12.FormControlName, i12.MaxLengthValidator, i17.FileUploadLibraryComponent, i18.CustomQuestionnaireComponent, i19.ButtonDirective, i13.NgClass, i20.EditorComponent, i21.ToolBarComponent, i21.ToolBarButtonGroupComponent, i21.ToolBarButtonComponent, i20.EditorBoldButtonDirective, i20.EditorItalicButtonDirective, i20.EditorUnderlineButtonDirective, i20.EditorStrikethroughButtonDirective, i20.EditorSubscriptButtonDirective, i20.EditorSuperscriptButtonDirective, i20.EditorAlignLeftButtonDirective, i20.EditorAlignCenterButtonDirective, i20.EditorAlignRightButtonDirective, i20.EditorAlignJustifyButtonDirective, i20.EditorFormatComponent, i20.EditorFontSizeComponent, i20.EditorFontFamilyComponent, i20.EditorColorPickerComponent, i20.EditorForeColorDirective, i20.EditorBackColorDirective, i20.EditorInsertUnorderedListButtonDirective, i20.EditorInsertOrderedListButtonDirective, i20.EditorIndentButtonDirective, i20.EditorOutdentButtonDirective, i20.EditorBlockquoteDirective, i20.EditorSelectAllButtonDirective, i20.EditorUndoButtonDirective, i20.EditorRedoButtonDirective, i20.EditorCreateLinkButtonDirective, i20.EditorUnlinkButtonDirective, i20.EditorInsertFileButtonDirective, i20.EditorViewSourceButtonDirective, i20.EditorCleanFormattingButtonDirective, i20.EditorInsertTableButtonComponent, i20.EditorAddColumnBeforeButtonDirective, i20.EditorAddColumnAfterButtonDirective, i20.EditorAddRowBeforeButtonDirective, i20.EditorAddRowAfterButtonDirective, i20.EditorDeleteColumnButtonDirective, i20.EditorDeleteRowButtonDirective, i20.EditorDeleteTableButtonDirective, i20.EditorMergeCellsButtonDirective, i20.EditorSplitCellButtonDirective, i20.EditorPrintDirective, i20.EditorInsertImageButtonDirective, i22.UploadImageDialogComponent, i23.RadioButton, i24.Dropdown, i12.DefaultValueAccessor, i25.InputText, i26.Tooltip, i27.MatIcon], styles: [".save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:0 30px!important;font-size:14px!important;border-radius:8px!important}.cancel-btn[_ngcontent-%COMP%]{border-radius:10px;text-transform:uppercase;font-size:12px;font-weight:700;padding:10px}.cancel-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:20px;padding:2px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}.subtask-form-header-buttons-holder[_ngcontent-%COMP%]{width:-moz-max-content;width:max-content}.subtask-form-header-buttons-holder[_ngcontent-%COMP%]   .subtask-form-trash[_ngcontent-%COMP%]{color:#4b8095;float:left;font-size:16px}.subtask-form-header-buttons-holder[_ngcontent-%COMP%]   .verticle-divider[_ngcontent-%COMP%]{background-color:#0977a3;width:1px;float:left;height:24px;margin:0 10px}.subtask-form-header-buttons-holder[_ngcontent-%COMP%]   .p-panel-header-icon[_ngcontent-%COMP%]{color:#777;float:left;width:24px;height:24px;background-color:#fff}.p-button-text[_ngcontent-%COMP%]{padding-left:8px!important;padding-right:8px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnterEntitiesRelationshipDetailsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-enter-entities-relationship-details-library',
                templateUrl: './enter-entities-relationship-details-library.component.html',
                styleUrls: ['./enter-entities-relationship-details-library.component.scss']
            }]
    }], function () { return [{ type: i1.DirtyFormGuard }, { type: i2.Store }, { type: i3.ReferenceLibraryService }, { type: i4.CacheCountryListService }, { type: i5.ToastrService }, { type: i6.ApiEnterEntitiesRelationshipDetailsLibraryService }, { type: i7.StepStatusUpdatePayloadService }, { type: i8.StepStatusUpdateComponentLibraryService }]; }, { primaryData: [{
            type: Input
        }], dialogClose: [{
            type: Output
        }], relationshipBetCompanyInfoupload: [{
            type: ViewChild,
            args: ["relationshipBetCompanyInfoupload"]
        }], principalProductOrServiceInfoupload: [{
            type: ViewChild,
            args: ["principalProductOrServiceInfoupload"]
        }], relationshipBetCompanyInfokendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["relationshipBetCompanyInfokendoeditor"]
        }], principalProductOrServiceInfokendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["principalProductOrServiceInfokendoeditor"]
        }] }); })();

class EnterEntitiesRelationshipDetailsLibraryModule {
}
EnterEntitiesRelationshipDetailsLibraryModule.ɵfac = function EnterEntitiesRelationshipDetailsLibraryModule_Factory(t) { return new (t || EnterEntitiesRelationshipDetailsLibraryModule)(); };
EnterEntitiesRelationshipDetailsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: EnterEntitiesRelationshipDetailsLibraryModule });
EnterEntitiesRelationshipDetailsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            USCompanyAdditionalDetailsLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            PrimengLibraryModule,
            FileUploadLibraryModule,
            ReactiveFormsModule,
            AssigningTaskLibraryModule,
            EditorModule,
            EditorLibraryModule,
            MaximizeDialogLibraryModule,
            CustomQuestionnaireModule
            // FroalaEditorModule.forRoot(),
            // FroalaViewModule.forRoot()
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(EnterEntitiesRelationshipDetailsLibraryModule, { declarations: [EnterEntitiesRelationshipDetailsLibraryComponent], imports: [USCompanyAdditionalDetailsLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        PrimengLibraryModule,
        FileUploadLibraryModule,
        ReactiveFormsModule,
        AssigningTaskLibraryModule,
        EditorModule,
        EditorLibraryModule,
        MaximizeDialogLibraryModule,
        CustomQuestionnaireModule
        // FroalaEditorModule.forRoot(),
        // FroalaViewModule.forRoot()
    ], exports: [EnterEntitiesRelationshipDetailsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnterEntitiesRelationshipDetailsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    EnterEntitiesRelationshipDetailsLibraryComponent
                ],
                imports: [
                    USCompanyAdditionalDetailsLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    PrimengLibraryModule,
                    FileUploadLibraryModule,
                    ReactiveFormsModule,
                    AssigningTaskLibraryModule,
                    EditorModule,
                    EditorLibraryModule,
                    MaximizeDialogLibraryModule,
                    CustomQuestionnaireModule
                    // FroalaEditorModule.forRoot(),
                    // FroalaViewModule.forRoot()
                ],
                exports: [
                    EnterEntitiesRelationshipDetailsLibraryComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of enter-entities-relationship-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EnterEntitiesRelationshipDetailsLibraryComponent, EnterEntitiesRelationshipDetailsLibraryModule, EnterEntitiesRelationshipDetailsLibraryService };
//# sourceMappingURL=enter-entities-relationship-details-library.js.map
